import { LabelControl } from "doshx_controls_web";
import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { useSearchDebounce } from "../hooks/useSearchDebounce";
export const IncrementButton = ({ labelSize = "small", value = 1, min = 1, max = 10, textColor = "text-black", backgroundColor = "bg-transparent", isLoading = false, enableDebounce = false, onChange, }) => {
    const { search, setSearchQuery } = useSearchDebounce(1100);
    const [count, setCount] = useState(value);
    useEffect(() => {
        setCount(value);
    }, [value]);
    useEffect(() => {
        if (search && onChange) {
            onChange(search);
        }
    }, [search]);
    const onUpdate = (value) => {
        setCount(value);
        if (onChange && !enableDebounce) {
            onChange(value);
        }
        else if (onChange && enableDebounce) {
            setSearchQuery(value);
        }
    };
    return (React.createElement("div", { className: `flex flex-row items-center ${backgroundColor} rounded-lg gap-1` },
        React.createElement("div", null,
            React.createElement("button", { className: "w-6 h-6 my-auto hover:opacity-60 ease-in-out duration-200", type: "button", disabled: isLoading, onClick: () => {
                    const newCount = count - 1;
                    if (newCount >= min) {
                        onUpdate(newCount);
                    }
                } },
                React.createElement("div", { className: "w-full h-full flex flex-col justify-center rounded-lg bg-neutral-gray text-dark-blue border border-dark-gray" },
                    React.createElement(Icon, { className: "mx-auto my-auto", icon: "lucide:minus", width: "12", height: "12" })))),
        React.createElement(LabelControl, { className: "min-w-[1.9rem] w-full flex justify-center items-center font-normal text-xs bg-white border-dark-gray border-1 rounded-lg h-6", size: labelSize, label: count.toString(), textColor: textColor }),
        React.createElement("div", null,
            React.createElement("button", { className: "w-6 h-6 my-auto hover:opacity-60 ease-in-out duration-200", type: "button", disabled: isLoading, onClick: () => {
                    const newCount = count + 1;
                    if (newCount <= max) {
                        onUpdate(newCount);
                    }
                } },
                React.createElement("div", { className: "w-full h-full flex flex-col justify-center rounded-lg bg-neutral-gray text-dark-blue border border-dark-gray text-sm" },
                    React.createElement(Icon, { className: "mx-auto my-auto", icon: "lucide:plus", width: "12", height: "12" }))))));
};
